export interface Microphone {
  name: string
  object: any
}

export const NO_MICROPHONE: Microphone = {
  name: 'No microphone',
  object: {},
}
